<template>
  <v-list-item :ripple="true">
    <v-list-item-title class="d-flex justify-space-between">
      <span v-sanitize="highlightTerms(item?.customerName, search)" />
      <span v-sanitize="highlightTerms(item?.id, search)" />
    </v-list-item-title>
    <v-list-item-subtitle class="d-flex justify-space-between">
      <span
        v-sanitize="
          highlightTerms(
            [item?.addressLine, item?.postcode].filter(Boolean).join(', '),
            search
          )
        "
      />
      <span v-sanitize="highlightTerms(item?.policyNumber, search)" />
    </v-list-item-subtitle>
  </v-list-item>
</template>

<script setup lang="ts">
import type { JobSearchItem } from '@/types/JobSearch'
import { highlightTerms } from '@/lib/highlight'

defineProps<{
  item: JobSearchItem
  search?: string
}>()
</script>

<style scoped>
:deep(.v-list-item__prepend > .v-icon) {
  margin-inline-end: 1rem;
}
</style>
